import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, createRef, provide } from 'intact-vue-next';
import template from './base.vdt';
import { sizes } from '../../styles/utils';
import { _$ } from '../../i18n';
import { useShowHideEvents } from '../../hooks/useShowHideEvents';
import { bind } from '../utils';
import { isFunction } from 'intact-shared';
import { useMouseOutsidable } from '../../hooks/useMouseOutsidable';
import { useDraggable } from './useDraggable';
import { useEscClosable } from './useEscClosable';
import { SHOW, HIDE, DIALOG } from './constants';
import { useFixBody, setHooks } from './useFixBody';
import { useConfigContext } from '../config';
var typeDefs = {
  title: String,
  value: Boolean,
  size: sizes,
  loading: Boolean,
  disabledOk: Boolean,
  okText: String,
  cancelText: String,
  ok: Function,
  cancel: Function,
  container: [String, Function],
  hideClose: Boolean,
  overlay: Boolean,
  closable: Boolean,
  terminate: Function,
  escClosable: Boolean,
  width: [String, Number],
  mode: ['destroy', 'hide'],
  draggable: Boolean
};
var defaults = function defaults() {
  return {
    title: _$('提示'),
    value: false,
    size: 'default',
    okText: _$('确定'),
    cancelText: _$('取消'),
    overlay: true,
    closable: true,
    escClosable: true,
    mode: 'hide',
    draggable: true
  };
};
var events = {
  open: true,
  close: true,
  ok: true,
  cancel: true,
  terminate: true,
  afterClose: true
};
export var BaseDialog = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BaseDialog, _Component);
  function BaseDialog() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.dialogRef = createRef();
    _this.overlayRef = createRef();
    _this.drag = useDraggable(_this.dialogRef, _this.overlayRef);
    _this.mouseOutsidable = useMouseOutsidable(_this.dialogRef, false);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = BaseDialog.prototype;
  _proto.init = function init() {
    useShowHideEvents('value', SHOW, HIDE);
    useFixBody(this.dialogRef);
    useEscClosable();
    provide(DIALOG, this);
  };
  _proto.show = function show(props) {
    this.set('value', true);
  };
  _proto.close = function close() {
    this.set('value', false);
  };
  _proto.showLoading = function showLoading() {
    this.set('loading', true);
  };
  _proto.hideLoading = function hideLoading() {
    this.set('loading', false);
  };
  _proto.disableOk = function disableOk() {
    this.set('disabledOk', true);
  };
  _proto.enableOk = function enableOk() {
    this.set('disabledOk', false);
  }
  /**
   * @brief
   * only be called by self when user clicks close button,
   * presses ESC or clicks overlay
   */;
  _proto.terminate = function terminate() {
    this.btnCallback('terminate');
  };
  _proto.ok = function ok() {
    this.btnCallback('ok');
  };
  _proto.cancel = function cancel() {
    this.btnCallback('cancel');
  };
  _proto.btnCallback = function btnCallback(type) {
    var callback = this.get(type);
    if (isFunction(callback)) {
      callback();
    } else {
      this.trigger(type);
      this.close();
    }
  };
  _proto.onClickWrapper = function onClickWrapper(e) {
    if (this.get('closable') && e.target === this.overlayRef.value) {
      this.terminate();
    }
  };
  _proto.onAfterLeave = function onAfterLeave() {
    this.trigger('afterClose');
  };
  return BaseDialog;
}(Component);
BaseDialog.template = template;
BaseDialog.typeDefs = typeDefs;
BaseDialog.defaults = defaults;
BaseDialog.events = events;
BaseDialog.setHooks = setHooks;
__decorate([bind], BaseDialog.prototype, "terminate", null);
__decorate([bind], BaseDialog.prototype, "ok", null);
__decorate([bind], BaseDialog.prototype, "cancel", null);
__decorate([bind], BaseDialog.prototype, "onClickWrapper", null);
__decorate([bind], BaseDialog.prototype, "onAfterLeave", null);